import $ from 'jquery';
import 'parsleyjs';
import './Language/parsley';
import 'emailDecrypt';
import 'picturefill';
import 'foreachfill';
import 'custom-event-polyfill';

// import './Libraries/LFM/BreakpointEvents';
import './Lightbox';
import './Jumplinks';
import './Select';
import './Menu';
import './Polygon';
import './Slider';
import './NavToggle';
// import './CookieConsent';
import './SiteHeader';
import './InteractiveMap';
import './InterfererSlider';
// import './BackToTop';
// import './LazyLoad';
// import './Gallery';
// import './Youtube';
// import './Maps';
import './Accordion';
import './Tiles';
import './Search';
import './Header';
import './Datepicker';
import './Jobs';
import './ContentPopup';

var isDev = process.env.NODE_ENV !== 'production';

if (isDev) {
    console.log('%cTheme.js successfully initialized with webpack! 🌊☀', "color: green");
}
$(window).trigger('resize');  // trigger once on page load
